import React from "react";
import BannerBG from "../../../assets/careers-banner-bg.png";
import { Link } from "react-router-dom";
import Phone from "../../../assets/phone.svg";
import Email from "../../../assets/email.svg";
import BannerContactForm from "./BannerContactForm";

function ContactBannerSection({ contact_banner }) {
  const defaultTitle = "Contact Us";
  const defaultContent =
    "Get in touch with us today to learn how Laguna Creek can lower your operating costs, save staff time and increase sales";
  const defaultPhoneNo = "(623) 300-2434";
  const defaultEmailAdd = "info@lagunacreek.io";
  const defaultInfoTitle1 = "Customer Support";
  const defaultInfoContent1 =
    "Our support team is available to address any concerns or queries you may have.";
  const defaultInfoTitle2 = "Feedback and Suggestions";
  const defaultInfoContent2 =
    "We value your feedback and are continuously working to improve Laguna Creek. Your input is crucial in shaping the future of Laguna Creek.";
  const defaultFormTitle = "Get in Touch";
  const defaultFormContent = "You can reach us anytime";

  const Title = contact_banner?.banner_title || defaultTitle;
  const Content = contact_banner?.banner_text || defaultContent;
  const PhoneNo = contact_banner?.banner_img || defaultPhoneNo;
  const EmailAdd = contact_banner?.banner_title || defaultEmailAdd;
  const InfoTitle1 = contact_banner?.banner_text || defaultInfoTitle1;
  const InfoContent1 = contact_banner?.banner_img || defaultInfoContent1;
  const InfoTitle2 = contact_banner?.banner_title || defaultInfoTitle2;
  const InfoContent2 = contact_banner?.banner_text || defaultInfoContent2;
  const FormTitle = contact_banner?.form_title || defaultFormTitle;
  const FormContent = contact_banner?.form_content || defaultFormContent;

  return (
    <>
      <section
        className="py-[30px] bg-cover"
        style={{
          backgroundImage: `url(${BannerBG})`,
        }}
      >
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4">
            <div className="w-full lg:w-1/2 xl:w-3/5 max-w-full px-4 mb-10 lg:mb-0">
              <div className="lg:max-w-[720px]">
                <div className="lg:max-w-[419px] mb-8">
                  <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-2.5">
                    {Title}
                  </h2>
                  <p className="text-lg font-light leading-7 text-[#333333] mb-7">
                    {Content}
                  </p>
                  <ul className="flex flex-col items-center gap-y-4">
                    <li className="w-full flex items-center gap-2.5">
                      <img
                        src={Phone}
                        alt="LinkedIn"
                        className="w-auto"
                        height="8"
                        width="19"
                      />
                      <Link
                        to={`tel:+1${PhoneNo.replace(/\D/g, "")}`}
                        className={`text-lg font-light leading-7 text-[#333333] transition-all ease-in-out duration-500 hover:text-[#faa42a]`}
                      >
                        {PhoneNo}
                      </Link>
                    </li>
                    <li className="w-full flex items-center gap-2.5">
                      <img
                        src={Email}
                        alt="LinkedIn"
                        className="w-auto"
                        height="8"
                        width="19"
                      />
                      <Link
                        to={`mailto:${EmailAdd}`}
                        className={`text-lg font-light leading-7 text-[#333333] transition-all ease-in-out duration-500 hover:text-[#faa42a]`}
                      >
                        {EmailAdd}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="flex flex-wrap justify-between gap-y-[30px] gap-x-[50px] xl:gap-x-[70px]">
                  <div className="w-full md:w-auto max-w-full">
                    <div className="md:max-w-[325px]">
                      <h3 className="text-xl md:text-2xl font-semibold leading-snug text-[#192020] mb-[5px]">
                        {InfoTitle1}
                      </h3>
                      <p className="text-lg font-light leading-[25px] text-[#192020]">
                        {InfoContent1}
                      </p>
                    </div>
                  </div>
                  <div className="w-full md:w-auto max-w-full">
                    <div className="md:max-w-[325px]">
                      <h3 className="text-xl md:text-2xl font-semibold leading-snug text-[#192020] mb-[5px]">
                        {InfoTitle2}
                      </h3>
                      <p className="text-lg font-light leading-[25px] text-[#192020]">
                        {InfoContent2}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2 xl:w-2/5 max-w-full px-4">
              <div className="lg:max-w-[500px] md:mr-0 md:ml-auto xl:ml-0 xl:mr-auto bg-[#B35526] py-8 px-8 md:px-12 rounded-[21px]">
                <h2 className="text-[30px] md:text-[40px] lg:text-[48px] font-normal leading-[1.3542] text-white">
                  {FormTitle}
                </h2>
                <p className="text-lg font-light leading-[1.667] text-white mb-8">
                  {FormContent}
                </p>
                <BannerContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactBannerSection;
